<template>
  <VForm
    :button="{
      class: 'primary full-size',
      label: $t('actions.continue'),
      hotDisabled: true,
    }"
    :externalRule="!isLoading"
    :callback="createUser"
  >
    <template #form-body="{ errors, setFieldError }">
      <div class="input-inline">
        <VField
          placeholder="Denis"
          name="firstname"
          v-model="userStore.user.first_name"
          rules="required|textOnly|min:1|max:50"
          icon="bi-person-vcard"
          :label="$t('form.register.firstName')"
          :class="{ invalid: Object.keys(errors)[0] === 'firstname' }"
          :disabled="hasAlreadyAnAccount"
        />
        <VField
          placeholder="Maurice"
          name="lastname"
          v-model="userStore.user.last_name"
          rules="required|textOnly|min:1|max:50"
          icon="bi-person-vcard"
          :label="$t('form.register.lastName')"
          :class="{ invalid: Object.keys(errors)[0] === 'lastname' }"
          :disabled="hasAlreadyAnAccount"
        />
      </div>
      <VField
        placeholder="Yuzu"
        name="company"
        v-model="userStore.user.company_name"
        rules="required|min:2|max:50"
        icon="bi-building"
        :label="$t('form.register.company')"
        :disabled="route.name === 'joinCompany'"
        :class="{ invalid: Object.keys(errors)[0] === 'company' }"
      />
      <VField
        rules="required|email|max:100"
        type="email"
        placeholder="adresse@email.com"
        name="email"
        v-model="userStore.user.email"
        icon="bi-at"
        :label="$t('form.email')"
        :disabled="route.name === 'joinCompany' || hasAlreadyAnAccount"
        :class="{ invalid: Object.keys(errors)[0] === 'email' }"
      />
      <div class="input-wrapper">
        <label v-text="$t('form.register.phone')" for="phone" />
        <vue-tel-input
          id="phone"
          v-model="state.phoneSubmit.formatted"
          :required="true"
          :styleClasses="{ invalid: !state.phoneIsValid && state.phoneBlur }"
          :disabled="hasAlreadyAnAccount"
          @on-input="formatNumber"
          @blur="
            () => {
              if (!state.phoneIsValid) {
                setFieldError('phone', getError('ERROR_INVALID_PHONE'));
              } else {
                setFieldError('phone', null);
              }

              state.phoneBlur = true;
            }
          "
        >
          <template v-slot:arrow-icon>
            <i class="bi bi-chevron-down" />
          </template>
          <template v-slot:icon-right>
            <i class="bi bi-telephone" />
          </template>
        </vue-tel-input>
      </div>
      <div class="input-inline">
        <VField
          type="password"
          placeholder="••••••••••••"
          name="password"
          v-model="userStore.user.password"
          rules="required|password"
          icon="bi-lock"
          :label="$t('form.password')"
          :helper="$t('form.register.must8char')"
          :class="{ invalid: Object.keys(errors)[0] === 'password' }"
          :disabled="hasAlreadyAnAccount"
        />
        <VField
          type="password"
          placeholder="••••••••••••"
          name="confirmPassword"
          v-model="userStore.user.confirm_password"
          icon="bi-lock"
          rules="required|match:@password"
          :label="$t('form.register.confirmPassword')"
          :class="{ invalid: Object.keys(errors)[0] === 'confirmPassword' }"
          :disabled="hasAlreadyAnAccount"
        />
      </div>
    </template>
  </VForm>
</template>

<script setup>
import { reactive, computed } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";
import { useUserStore } from "@/stores/user.js";

const userStore = useUserStore();

const emits = defineEmits(["validation"]);

const props = defineProps({
  toCheck: {
    type: String,
    default: "",
  },
  isLoading: {
    type: Boolean,
    required: true,
  },
});

const toast = useToast();

const route = useRoute();

const state = reactive({
  emailSubmit: null,
  phoneSubmit: {
    formatted: userStore.user.phone_number || null,
  },
});

const hasAlreadyAnAccount = computed(() => {
  return userStore.user?.user_id?.length > 0;
});

function formatNumber(formattedNumber, phoneObject) {
  state.phoneSubmit = phoneObject;
  state.phoneIsValid = phoneObject.valid;
}

async function createUser() {
  if (props.toCheck === "EMAIL" && userStore.user.email === state.emailSubmit) {
    toast.error(getError("ERROR_INVALID_EMAIL"));
    return;
  }

  if (
    props.toCheck === "PHONE" &&
    userStore.user.phone_number === state.phoneSubmit
  ) {
    toast.error(getError("ERROR_INVALID_PHONE"));
    return;
  }

  userStore.user.phone_number = state.phoneSubmit.number;

  state.emailSubmit = userStore.user.email;

  emits("validation");
}
</script>
